import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { LandingPrimaryCta, LandingReveal } from './landing-shared';

export const LandingCtaSection = ({ signedIn }: { signedIn: boolean }) => {
  const { t } = useTranslation('landing');

  return (
    <section
      className="landing-cta-bg landing-section-separator relative overflow-hidden px-4 py-16 sm:px-6 sm:py-20"
      aria-labelledby="landing-cta-heading"
    >
      <LandingReveal variant="scale" className="relative z-10 mx-auto max-w-2xl text-center">
        <h2
          id="landing-cta-heading"
          className="landing-display text-balance text-[1.75rem] font-semibold tracking-tight sm:text-[2rem]"
        >
          {t('cta.title')}
        </h2>
        <p className="mx-auto mt-3 max-w-lg text-pretty text-body leading-relaxed text-on-brand/90 sm:text-card-title">
          {t('cta.subtitle')}
        </p>
        <div className="mt-8 flex flex-col items-center gap-3">
          <LandingPrimaryCta
            signedIn={signedIn}
            size="lg"
            className="w-full bg-on-brand text-brand shadow-e2 hover:bg-on-brand/90 active:bg-on-brand/85 sm:w-auto"
          />
          {!signedIn ? (
            <Link
              to="/sign-in"
              className="text-body text-on-brand underline-offset-4 hover:underline"
            >
              {t('cta.signIn')}
            </Link>
          ) : null}
        </div>
      </LandingReveal>
    </section>
  );
};
